import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Descriptions, Spin, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import Layout from '@/common/Layout';
import { getDrumLabel } from '@/features/drumLabel/redux/slice';

const badgeStyle = (bg) => ({
  background: bg,
  color: '#fff',
  padding: '2px 10px',
  borderRadius: 10,
  fontSize: 12,
  fontWeight: 600
});

const DrumDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { current, loading } = useSelector((state) => state.drumLabel);

  useEffect(() => {
    if (id) dispatch(getDrumLabel(id));
  }, [id]);

  const renderStatus = (s) => (
    <span style={badgeStyle(s === 'batch_processing' ? '#fa8c16' : '#d4380d')}>
      {s === 'batch_processing' ? 'Batch Processing' : 'Uncleaned'}
    </span>
  );

  const renderActive = (v) => (
    <span style={badgeStyle(v ? '#389e0d' : '#8c8c8c')}>
      {v ? 'Active' : 'Inactive'}
    </span>
  );

  return (
    <Layout sider={false}>
      <div style={{ padding: 16 }}>
        <Card title="DRUM Label Details" loading={loading}>
          {loading && !current ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <Spin />
            </div>
          ) : !current ? (
            <p>DRUM label not found.</p>
          ) : (
            <>
              {current.pdf_url && (
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    href={current.pdf_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={`${current.drum_label_number}.pdf`}
                  >
                    Download Label PDF
                  </Button>
                </div>
              )}
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="DRUM Label Number">
                  <span style={{ fontFamily: 'monospace' }}>
                    {current.drum_label_number}
                  </span>
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {renderStatus(current.status)}
                </Descriptions.Item>
                <Descriptions.Item label="Is Active">
                  {renderActive(current.is_active)}
                </Descriptions.Item>
                <Descriptions.Item label="Cleaned">
                  {current.is_cleaned ? 'Yes' : 'No'}
                </Descriptions.Item>
                <Descriptions.Item label="Product Batch Number">
                  {current.product_batch_number || '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Product Name">
                  {current.product_name || '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Process">
                  {current.process || '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Next Stage">
                  {current.nextstage || '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Created At">
                  {current.createdAt
                    ? moment(current.createdAt).format('DD-MM-YYYY HH:mm')
                    : '—'}
                </Descriptions.Item>
                <Descriptions.Item label="Updated At">
                  {current.updatedAt
                    ? moment(current.updatedAt).format('DD-MM-YYYY HH:mm')
                    : '—'}
                </Descriptions.Item>
              </Descriptions>
            </>
          )}
        </Card>
      </div>
    </Layout>
  );
};

export default DrumDetails;
